import React from 'react';

const Button = ({ href, children, icon: Icon, ...props }) => {
  const buttonStyle = {
    backgroundColor: 'transparent',
    border: '1px solid #64ffda',
    color: '#64ffda',
    padding: '0.5rem 1.5rem',
    borderRadius: '4px',
    textDecoration: 'none',
    margin: '0 0.5rem',
    transition: 'all 0.3s ease',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: '500',
    letterSpacing: '0.5px',
    textTransform: 'uppercase'
  };

  return (
    <a
      href={href}
      style={buttonStyle}
      onMouseOver={(e) => {
        e.target.style.backgroundColor = 'rgba(100, 255, 218, 0.1)';
      }}
      onMouseOut={(e) => {
        e.target.style.backgroundColor = 'transparent';
      }}
      {...props}
    >
      {Icon && <Icon size={20} />}
      {children}
    </a>
  );
};

export default Button; 